
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.447 23.875a5.401 5.401 0 01-3.801-1.549L1.839 9.52A5.396 5.396 0 01.248 5.679c0-1.451.565-2.815 1.591-3.841A5.396 5.396 0 015.68.247c1.451 0 2.815.565 3.841 1.591l12.733 12.734c2.135 2.092 2.169 5.537.073 7.676a5.39 5.39 0 01-3.88 1.627zm-2.749-2.618a3.911 3.911 0 002.749 1.119 3.9 3.9 0 002.809-1.178 3.938 3.938 0 00-.057-5.561l-4.059-4.059-5.561 5.561 4.119 4.118zm-5.179-5.179l5.561-5.561-2.505-2.505-5.561 5.561 2.505 2.505zM5.68 1.748a3.905 3.905 0 00-2.781 1.15 3.937 3.937 0 000 5.561l4.054 4.054 5.561-5.561-4.053-4.054a3.905 3.905 0 00-2.781-1.15z"}}),_c('path',{attrs:{"d":"M15.563 18.727c-.3 0-.582-.116-.794-.326l-.01-.01a1.127 1.127 0 01.008-1.583.384.384 0 01.052-.043c.2-.182.468-.286.747-.286.297 0 .575.114.786.32l.009.008c.439.441.439 1.154.002 1.592a.357.357 0 01-.05.042 1.12 1.12 0 01-.75.286zM19.642 18.727c-.254 0-.504-.09-.706-.253l-.039-.031a.446.446 0 01-.082-.077 1.105 1.105 0 01-.298-.765c0-.295.114-.573.32-.783l.01-.011a1.122 1.122 0 011.505-.07l.017.012a1.117 1.117 0 01.397.858c0 .3-.118.582-.331.794-.211.21-.493.326-.793.326zM4.363 7.523c-.301 0-.583-.117-.795-.329a1.13 1.13 0 01-.001-1.592c.212-.212.494-.329.795-.329.297 0 .576.114.787.321l.009.009c.213.213.329.496.329.796a1.116 1.116 0 01-.329.795 1.118 1.118 0 01-.795.329zM8.437 7.523a1.126 1.126 0 01-1.125-1.126c0-.268.098-.526.274-.73a.444.444 0 01.052-.064c.212-.213.494-.33.795-.33.3 0 .583.117.795.329.415.419.437 1.081.058 1.525a.406.406 0 01-.054.067 1.118 1.118 0 01-.795.329z"}})])
          )
        }
      }
    